import {CASEALERT_MARKREAD} from "typeConstants";

const caseAlertMarkRead = (id) => {
    return dispatch => ( dispatch({
        type: CASEALERT_MARKREAD,
        payload: id,
    }));
};


export {
    caseAlertMarkRead,
};